import { Injectable } from '@angular/core';
import { Router, CanActivate, Route, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';

@Injectable()
export class MainGuard implements CanActivate {

  permiso: any = {};

  constructor(
    private router: Router,
    private _authService: AuthService,
  ) {
  }
  canActivate(_route: ActivatedRouteSnapshot): boolean {
    const url = `/${_route}`;
    if (this._authService.isLoggedIn()) {
      return true;
    } else if (this._authService.isTokenExpired()) {
      this._authService.expireSession();
      return false;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
